import script from "./BindingTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BindingTab.vue?vue&type=script&setup=true&lang=js"

import "./BindingTab.vue?vue&type=style&index=0&id=1a69d399&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a69d399"]])

export default __exports__